module.exports = __webpack_public_path__ + "img/张凤荣.45204b34.jpg";